export default "__VITE_ASSET__BbLZYVyX__"